import { Select, Table } from "antd";
import { Content } from "antd/lib/layout/layout";
import { automatedPaymentBatchColumns } from "./automated_payment_batch_columns";
import { getAdminPaymentBatches } from "./automated_payment_batches.api";
import { getBrands } from "components/brands/brands.api";
import { useEffect, useMemo, useState } from "react";
import { SORT_DIRECTIONS } from "common/constants";

export const AutomatedPaymentBatches = () => {
    const [brands, setBrands] = useState([]);
    const [brandsLoading, setBrandsLoading] = useState(false);
    const [selectedBrandUserId, setSelectedBrandUserId] = useState(null);
    const [batches, setBatches] = useState([]);
    const [batchesLoading, setBatchesLoading] = useState(false);

    const fetchBatches = (brandUserId = null) => {
        setBatchesLoading(true);
        getAdminPaymentBatches(brandUserId)
            .then((result) => setBatches(result?.data ?? []))
            .finally(() => setBatchesLoading(false));
    };

    useEffect(() => {
        setBrandsLoading(true);
        getBrands()
            .then((data) => setBrands(data ?? []))
            .finally(() => setBrandsLoading(false));
        fetchBatches();
    }, []);

    const onBrandChange = (brandUserId) => {
        const id = brandUserId ?? null;
        setSelectedBrandUserId(id);
        fetchBatches(id);
    };

    const brandOptions = useMemo(
        () =>
            brands
                .filter((b) => b?.role === "Owner")
                .sort((a, b) =>
                    (a?.businessName ?? "").localeCompare(
                        b?.businessName ?? "",
                    ),
                )
                .map((b) => ({
                    value: b.userId,
                    label: b.businessName ?? b.fullName ?? String(b.userId),
                })),
        [brands],
    );

    const columns = useMemo(() => {
        const statusFilters = [
            ...new Set(batches.map((b) => b?.statusDescr).filter(Boolean)),
        ]
            .sort()
            .map((s) => ({ text: s, value: s }));

        const achStatusFilters = [
            ...new Set(
                batches.map((b) => b?.achTransferStatusDescr).filter(Boolean),
            ),
        ]
            .sort()
            .map((s) => ({ text: s, value: s }));

        return automatedPaymentBatchColumns.map((col) => {
            if (col.key === "statusDescr") {
                return { ...col, filters: statusFilters };
            }
            if (col.key === "achTransferStatusDescr") {
                return { ...col, filters: achStatusFilters };
            }
            return col;
        });
    }, [batches]);

    return (
        <Content style={{ padding: 24 }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    marginBottom: 24,
                }}>
                <Select
                    allowClear
                    filterOption={(input, option) =>
                        option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    loading={brandsLoading}
                    onChange={onBrandChange}
                    options={brandOptions}
                    placeholder="Select a brand"
                    showSearch
                    style={{ width: 300 }}
                    value={selectedBrandUserId}
                />
            </div>
            <Table
                bordered
                columns={columns}
                dataSource={batches}
                loading={batchesLoading}
                locale={{ emptyText: "No payment batches found" }}
                pagination={{
                    position: ["bottomCenter"],
                    hideOnSinglePage: true,
                    pageSizeOptions: [20, 50, 100],
                    defaultPageSize: 20,
                    showTotal: (total) => `Total ${total} items`,
                }}
                rowKey={(record) => `${record.brandUserId}-${record.id}`}
                scroll={{
                    scrollToFirstRowOnChange: true,
                    y: "calc(100vh - 220px)",
                    x: 1100,
                }}
                size="small"
                sortDirections={SORT_DIRECTIONS}
                style={{ width: "100%", height: "100%" }}
            />
        </Content>
    );
};
